<template>
  <div class="wrapper-indicadores">
    <div
      v-for="(item, index) of news.metrica"
      :key="index"
      class="text-center contenedor-indicador"
    >
      <h4 class="titulo-indicador">- {{ item.name }} -</h4>
      <div class="itemd-indicadores">
        <div
          v-for="(items, index) of item.details"
          :key="index"
          class="col-indicadores"
        >
          <img :src="`${items.image}`" /><br />
          <h3 class="valor-indicador">
            <number
              ref="number1"
              :from="2000"
              :to="items.valor"
              :format="theFormat"
              :duration="5"
              :delay="0"
            />
          </h3>
          <p class="valor-texto">{{ items.indicador }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueNumber from "vue-number-animation";

Vue.use(VueNumber);
const newsUrl =
  "https://srv-si-001.utpl.edu.ec/apim/biblioteca/1.0/indicadores/v1/estadisticas";

const config = {
  headers: {
    apikey:
      "eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.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.SWKFlpWqBdVgB6z6WGh_R-pK9FiMLZ7gps2S2zp2Hg5K3Sg4CGLq2XTSUpsGY0pWjX0_RO3ucnQMYHL85-EL4_osZRq6QoH-jUMQq_foWIuxJ-tx51Pip2aCaVOMO4TxL-P-S8HSOEvV1hWpp5UbzI0XAAhG8ORwWxBZebAxsbNdvBl85MVxr9dj5hoPz0YkHtjCC9xwgyRSez5LJpWZwzAKBecdhsY86nJl2Vuf43LNxdqTo_h8avg5ewWem9wR4Cgz2MNuRxu-AoszLL2bTDDHZRl7PAJJUjkhtIP_ndsYVOaj6IwYSEbwyZwTHpfis9hI3DQlRlobxkqEllUnpg==",
  },
};

export default {
  name: "utpl-biblioteca-instalaciones",

  data() {
    return { news: [] };
  },
  methods: {
    getNews() {
      axios
        .get(newsUrl, config)
        .then((response) => (this.news = response.data));
    },
  },
  created() {
    this.getNews();
  },
};
</script>
<style>
@import "../styles/style-biblioteca-instalaciones.css";
</style>
